export const PASSWORD_VALIDTION_LENGTH = 'length' as const
export const PASSWORD_VALIDTION_NUMBER = 'number' as const
export const PASSWORD_VALIDTION_UPPERCASE = 'uppercase' as const
export const PASSWORD_VALIDTION_LOWERCASE = 'lowercase' as const

export const PASSWORD_REQUIREMENT_LENGTH = /.{8,}/ // At least 8 characters
export const PASSWORD_REQUIREMENT_NUMBER = /\d/ // At least one number
export const PASSWORD_REQUIREMENT_UPPERCASE = /[A-Z]/ // At least one uppercase letter
export const PASSWORD_REQUIREMENT_LOWERCASE = /[a-z]/ // At least one lowercase letter

// user-auth validation fields we have copy for; a 422 on any other field is contract drift.
export const PASSWORD_RESET_FIELD_MESSAGES: Record<string, string> = {
    password: 'core.passwordReset.passwordRejected',
    email: 'core.validationRules.email.invalid',
}
